
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(152|323|591|608)|(410|571|633)2|1096|2646|2829|4294|5513|8279|9153)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
